export const SITE_NAME = 'Fam';
export const SITE_TAGLINE = 'Zasługujesz na kogoś, kto cię wysłucha';
export const DEFAULT_DESCRIPTION =
  'Fam łączy Cię z osobami, które rozumieją Twoje doświadczenia. Anonimowe rozmowy i wsparcie w trudnych chwilach.';

export function getSiteUrl() {
  const url = process.env.REACT_APP_SITE_URL;
  if (url) return url.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'https://fam.app';
}
